var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoMini = function SvgLogoMini(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 46,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logoMini_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#202124",
    d: "m41.44 34.26-20.4 11.036L.376 34.602l20.486-10.818z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFD433",
    d: "m41.694 31.74-19.669-9.801L21.843.166l19.678 10.908z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#224FF0",
    d: "M.494 31.73.32 10.931 19.596.372l.177 21.156z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logoMini_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h42v46H0z"
  })))));
};
export default SvgLogoMini;